import React from 'react';
import { Center as CenterStyled } from '../styles';

export const Center = ({ children, padding, className }) => (
  <CenterStyled
    className={['builder-center', className].filter(Boolean).join(' ')}
    padding={padding}
  >
    {children}
  </CenterStyled>
);
